import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../../contexts/LanguageContext';
import {
  NAV_ITEMS,
  MOBILE_MENU_INITIAL,
  MOBILE_MENU_OPEN,
  MOBILE_MENU_CLOSED,
} from './navbarConfig';

const MobileDropdown = ({ isOpen, onNavigate }) => {
  const { t } = useLanguage();

  return (
    <motion.div
      initial={MOBILE_MENU_INITIAL}
      animate={isOpen ? MOBILE_MENU_OPEN : MOBILE_MENU_CLOSED}
      inert={!isOpen}
      aria-hidden={!isOpen}
      data-testid="mobile-dropdown"
      className="md:hidden overflow-hidden bg-slate-900/95 backdrop-blur-md"
    >
      <div className="px-4 py-4 space-y-3">
        {NAV_ITEMS.map((item) => (
          <button
            key={item.id}
            onClick={() => onNavigate(item.id)}
            data-testid={`mobile-nav-${item.id}`}
            className="block w-full text-left px-4 py-3 text-white/90 hover:text-white font-bold tracking-wide hover:bg-slate-800/80 hover:shadow-lg hover:shadow-orange-500/20 rounded-lg transition-all duration-300 relative group"
          >
            {t.nav[item.labelKey]}
            <span className="absolute bottom-2 left-4 w-0 h-0.5 bg-gradient-to-r from-orange-500 to-blue-400 group-hover:w-[calc(100%-2rem)] transition-all duration-500"></span>
          </button>
        ))}
        <button
          onClick={() => onNavigate('contact')}
          data-testid="mobile-nav-appointment-btn"
          className="w-full px-6 py-3 rounded-lg bg-gradient-to-r from-orange-500 to-orange-600 text-white font-semibold"
        >
          {t.nav.getAppointment}
        </button>
      </div>
    </motion.div>
  );
};

export default MobileDropdown;
